import React, { createContext, useState } from 'react';
import { toast } from 'react-toastify';
import { apiOnboarding } from '../services/api';

export const ArquivosExternosContext = createContext([]);

export function ArquivosExternosProvider(props) {
	const { children } = props;

	const [bannersLista, setBannersLista] = useState([]);

	async function getBanners() {
		try {
			const response = await apiOnboarding.get(`/banner`,
				{
					headers: {
						'Content-Type': 'application/json',
					},
				}).then(res => {
					setBannersLista(res.data.dados)
				});
			return response;
		} catch (error) {
			toast.error(
				'Banners não carregados. Por favor atualize a página.'
			);
		}
		return null;
	}

	return (
		<ArquivosExternosContext.Provider
			value={{
				getBanners,
				bannersLista
			}}>
			{children}
		</ArquivosExternosContext.Provider>
	);
}
